// extracted by mini-css-extract-plugin
export var cartContainer = "_m5-4";
export var gray = "_m5-1";
export var itemContainer = "_m5-2";
export var itemDetails = "_m5-3";
export var strong = "_m5-0";